import { useMemo, useState, useCallback } from 'react';
import { useTheme } from 'styled-components';
import { useIsomorphicLayoutEffect } from '../useIsomorphicLayoutEffect/useIsomorphicLayoutEffect.esm.js';
import { isSsr } from '../../helpers/ssr.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var DEFAULT_TABLET_WIDTH = 768;
var DEFAULT_DESKTOP_WIDTH = 1024;
var DEFAULT_BREAKPOINTS = [
    DEFAULT_TABLET_WIDTH,
    DEFAULT_DESKTOP_WIDTH
];
var INITIAL_STATE = {
    width: 0,
    height: 0,
    matchingBreakpoint: 0,
    isMobileViewport: false,
    isTabletViewport: false,
    isBelowDesktopViewport: false,
    isDesktopViewport: false
};
var getPageSize = function(param) {
    var breakpoints = param.breakpoints;
    if (isSsr()) return INITIAL_STATE;
    var width = window.innerWidth;
    var height = window.innerHeight;
    var matchingBreakpoint = breakpoints.reduceRight(function(acc, curWidth, index) {
        if (width < curWidth) {
            return index;
        }
        return acc;
    }, breakpoints.length);
    var isMobileViewport = matchingBreakpoint === 0;
    var isTabletViewport = matchingBreakpoint === 1;
    var isBelowDesktopViewport = matchingBreakpoint < 2;
    var isDesktopViewport = matchingBreakpoint >= 2;
    return {
        width: width,
        height: height,
        isMobileViewport: isMobileViewport,
        isTabletViewport: isTabletViewport,
        isBelowDesktopViewport: isBelowDesktopViewport,
        isDesktopViewport: isDesktopViewport,
        matchingBreakpoint: matchingBreakpoint
    };
};
var useViewportSize = function() {
    var theme = useTheme();
    var breakpoints = useMemo(function() {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        return theme != null && theme.breakpoints.length !== 0 ? theme.breakpoints.map(function(v) {
            return Number.parseInt(v.replace("px", ""));
        }) : DEFAULT_BREAKPOINTS;
    }, [
        theme
    ]);
    var _useState = _sliced_to_array(useState(INITIAL_STATE), 2), _useState_ = _useState[0], width = _useState_.width, height = _useState_.height, isMobileViewport = _useState_.isMobileViewport, isTabletViewport = _useState_.isTabletViewport, isBelowDesktopViewport = _useState_.isBelowDesktopViewport, isDesktopViewport = _useState_.isDesktopViewport, matchingBreakpoint = _useState_.matchingBreakpoint, setState = _useState[1];
    var onResize = useCallback(function() {
        var size = getPageSize({
            breakpoints: breakpoints
        });
        setState(size);
    }, [
        breakpoints
    ]);
    useIsomorphicLayoutEffect(function() {
        if (isSsr()) return;
        window.addEventListener("resize", onResize, {
            passive: true
        });
        setState(getPageSize({
            breakpoints: breakpoints
        }));
        return function() {
            window.removeEventListener("resize", onResize);
        };
    }, []);
    useIsomorphicLayoutEffect(function() {
        if (isSsr()) return;
        var size = getPageSize({
            breakpoints: breakpoints
        });
        setState(size);
    }, [
        breakpoints
    ]);
    if (isSsr()) return INITIAL_STATE;
    return {
        width: width,
        height: height,
        isMobileViewport: isMobileViewport,
        isTabletViewport: isTabletViewport,
        isBelowDesktopViewport: isBelowDesktopViewport,
        isDesktopViewport: isDesktopViewport,
        matchingBreakpoint: matchingBreakpoint
    };
};

export { DEFAULT_BREAKPOINTS, DEFAULT_DESKTOP_WIDTH, DEFAULT_TABLET_WIDTH, useViewportSize };
